import React, { useContext } from 'react';

import { ApplicationUIContext, AntdPageHeader } from '@yuhuinc/ui-library';

import { Form } from 'antd';
import { Draft } from './Form/constants';
import Configuration from './Form/Configuration';

export default function PackageForm({
  formTitle,
  formName,
  formData,
  onClickBackButton,
  actionButtons,
}) {
  const [form] = Form.useForm();

  const { isMobile } = useContext(ApplicationUIContext);

  const initialValues = {
    id: formData?.id,
    status: formData?.status || Draft,
    name: formData?.name,
    description: formData?.description,
    lead_applicant_template_id: formData?.lead_applicant_template_id,
    coapplicant_template_id: formData?.coapplicant_template_id,
    guarantor_template_id: formData?.guarantor_template_id,
    landlord_reference_template_id: formData?.landlord_reference_template_id,
    employer_reference_template_id: formData?.employer_reference_template_id,
    personal_reference_template_id: formData?.personal_reference_template_id,
    deposit_required: formData?.deposit_required || 'lease_creation',
    lead_applicant_documents: formData?.lead_applicant_documents || [],
    coapplicant_documents: formData?.coapplicant_documents || [],
    guarantor_documents: formData?.guarantor_documents || [],
    unit_ids: formData?.unit_ids || [],
  };

  return (
    <Form
      form={form}
      layout="vertical"
      size={isMobile && 'large'}
      formname={formName}
      initialValues={initialValues}
      scrollToFirstError
    >
      <AntdPageHeader
        onBack={onClickBackButton}
        title={formTitle}
        status={initialValues.status}
        extra={actionButtons}
      >
        <Configuration />
      </AntdPageHeader>
    </Form>
  );
}
